import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 118px);
  margin-bottom: 62px;
`;
